import { Injectable } from "@angular/core";
import { DomainService } from "@app/core/services/domain.service";
import { safeGet } from "@app/shared/utils/secure/safe-get";
import { IndividualConfig, ToastrService } from "ngx-toastr";

export enum ToasterPosition {
  topRight = "toast-top-right",
  topLeft = "toast-top-left",
  bottomRight = "toast-bottom-right",
  bottomLeft = "toast-bottom-left",
}

@Injectable({
  providedIn: "root",
})
export class ToastService {
  private delayEnd = 0;

  get _colorDomain(): any {
    return this._domain.getColoredDomain();
  }

  constructor(
    private _toastrService: ToastrService,
    private _domain: DomainService,
  ) {}

  // skipDelay параметр нужен для того, чтобы скрыть сообщения из интерсептора и не только
  multipleErrorToast(
    error: any,
    config: Partial<IndividualConfig> = {},
    timeOut = 5000,
    skipDelay = 0,
  ): void {
    const now = new Date().getTime();
    if (now < this.delayEnd) {
      return;
    }
    this.delayEnd = now + skipDelay;
    Object.keys(error).forEach((prop: string) => {
      const value = safeGet(error, prop);
      if (Array.isArray(value)) {
        this._toastrService.error(value.join(", "), "", {
          ...config,
          timeOut,
        });
      } else {
        this._toastrService.error(value, "", { ...config, timeOut });
      }
    });
  }

  // skipDelay параметр нужен для того, чтобы скрыть сообщения из интерсептора и не только
  error(
    error: any,
    config: Partial<IndividualConfig> = {},
    timeOut = 5000,
    skipDelay = 0,
  ): void {
    const now = new Date().getTime();
    if (now < this.delayEnd) {
      return;
    }
    this.delayEnd = now + skipDelay;
    this._toastrService.error(error, "", { ...config, timeOut });
  }

  success(message: string, config: Partial<IndividualConfig> = {}): void {
    this._toastrService.success(message, "", {
      toastClass: `${this._colorDomain} ngx-toastr`,
      ...config,
    });
  }
}
